import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { getRuntimeConfig, loadRuntimeConfig, RUNTIME_CONFIG } from './app/core/runtime-config';

void loadRuntimeConfig()
  .catch(() => getRuntimeConfig())
  .then(() =>
    bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [...appConfig.providers, { provide: RUNTIME_CONFIG, useValue: getRuntimeConfig() }],
    })
  )
  .catch((err) => console.error(err));
